import Vue from 'vue';
import { actionTypes, mutationTypes, articleTypes } from '@/types';
import { uiStates, uiComponents, mutuallyExclusiveComponentsList } from '@/tools/viewState';

// To prevent circular dependencies the initialize function takes the
let store;
export function initializeAfterEach(_store) {
	store = _store;
}

// Load style template, if the exhibition (e.g. 'root' exhibiton) does not have one
// use the global style template.
export async function setStyleTemplate(to) {
	if (!store.state.cssDevMode) {
		const { exhibitionID } = to.params;
		store.dispatch(actionTypes.setStyleTemplate, { exhibitionID });
	}
}

export function closeModals(to, from) {
	// close
	if (from.params.articleID === articleTypes.articleList) {
		store.commit(mutationTypes.viewStateSetUiState, {
			id: uiComponents.uiSearchArticles,
			uiState: uiStates.hidden,
		});
	}
	if (to.query.retainModal) {
		const id = mutuallyExclusiveComponentsList.reduce((acc, entry) => {
			return store.state.viewState[entry].uiState !== uiStates.hidden ? entry : acc;
		}, false);
		if (id) {
			store.commit(mutationTypes.viewStateSetUiState, { id, uiState: uiStates.hidden });
		}
	}
}

/**
 * this method calucaltes left and right by tour articles if there is no tourEntry article set it uses
 * landing article if tour ends.
 * @param {*} state.tour
 * @param {*} step
 */
function calcStep({ current, position }, step) {
	/* eslint-disable no-nested-ternary */
	return position + step >= 0 && position + step < current.exhibitIDs.length
		? {
				exhibitionID: current.exhibitionID,
				tourID: current.id,
				articleID: current.exhibitIDs[position + step].articleID,
		  }
		: current.endTourOnlyOnCommand
		? null
		: {
				exhibitionID: current.tourEntryExhibitionID
					? current.tourEntryExhibitionID
					: store.state.dataSourceCFG.landingExhibition.exhibitionID,
				tourID: null,
				articleID: current.tourEntryArticleID
					? current.tourEntryArticleID
					: store.state.dataSourceCFG.landingExhibition.landingArticleID,
		  };
}
export function setContent(to) {
	Vue.nextTick(() => {
		// after the navigation is confirmed, set State
		const { exhibitionID, tourID, articleID } = to.params;
		const exhibition = store.state.dataSourceCFG.exhibitionMap[exhibitionID];

		const tour = store.state.tour.toursMap[tourID];
		let tourPosition;
		const article = exhibition.articleMap[articleID];

		store.commit(mutationTypes.setExhibitionID, { exhibition });
		if (tour) {
			// set tour and calculate tour position
			tourPosition = tour.exhibitIDs.findIndex(element => element.articleID === articleID);
			if (tour.endTourOnlyOnCommand && tourPosition === -1) tourPosition = store.state.tour.position;
			store.commit(mutationTypes.tourSetCurrent, {
				tourID,
				position: tourPosition,
			});
			// load tour navigation
			store.dispatch(actionTypes.tourSetNavigation);
		} else {
			if (store.state.tour.active) {
				// tour is active from last page now it has to be closed
				store.dispatch(actionTypes.tourEnd, { doNotRedirect: true });
			}
		}
		// hast to be in vue nextTick so browser historyKey is updated and ower own history Stack is working correctly
		store.commit(mutationTypes.historyUpdate, { exhibitionID, tourID, articleID, tourPosition });
		store.commit(mutationTypes.historySetCurrentKey);
		store.commit(mutationTypes.setArticleID, { article });

		if (store.state.tour.active) {
			// If tour is active left and write has to be calculated
			store.dispatch(actionTypes.swipeUpdateArticlePoperties, {
				leftArticleProperties: calcStep(store.state.tour, -1),
				rightArticleProperties: calcStep(store.state.tour, +1),
				updatedBy: 'router',
			});
		} else {
			store.dispatch(actionTypes.swipeUpdateArticlePoperties, {
				updatedBy: 'router',
			});
		}
		store.commit(mutationTypes.viewStateSetUiState, [
			// Show the article component
			{
				id: uiComponents.wrapperArticleCurrent,
				uiState: uiStates.maximised,
			},
			// Hide the loading animation.
			{
				id: uiComponents.uiLoader,
				uiState: uiStates.hidden,
			},
		]);
	});
}
